var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOmbor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_365_3061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 18.3V6.42375C0 5.44125 0.59625 4.56 1.5075 4.19625L11.5538 0.179999C11.8388 0.0637491 12.1575 0.0637491 12.4462 0.179999L22.4925 4.19625C23.4038 4.56 24 5.445 24 6.42375V18.3C24 18.7987 23.5988 19.2 23.1 19.2H21.3C20.8013 19.2 20.4 18.7987 20.4 18.3V8.4C20.4 7.73625 19.8638 7.2 19.2 7.2H4.8C4.13625 7.2 3.6 7.73625 3.6 8.4V18.3C3.6 18.7987 3.19875 19.2 2.7 19.2H0.9C0.40125 19.2 0 18.7987 0 18.3ZM18.3 19.2H5.7C5.20125 19.2 4.8 18.7987 4.8 18.3V16.2H19.2V18.3C19.2 18.7987 18.7987 19.2 18.3 19.2ZM4.8 15V12.6H19.2V15H4.8ZM4.8 11.4V8.4H19.2V11.4H4.8Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_365_3061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 19.2,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmbor);
export default __webpack_public_path__ + "static/media/ombor.1e8756687227e25ed75f7b516f6019f7.svg";
export { ForwardRef as ReactComponent };